/**
 * Assigner
 * 
 * Objects for lead source/category assignment.
 */
import { SessionProfile, SessionProfileAttribute } from "./session";


interface MatchValue {
    value: string;
    isRegex: boolean;
    isNegative: Boolean;
}

export interface MatchClause {

    matchValues: MatchValue[];
    attribute: SessionProfileAttribute;
    primaryOnly: Boolean;

}

interface MatchAssignment {
    clauses: MatchClause[];
    assignSources: string[];
    assignCategories: string[];
}


export interface MatchConfig {
    version: number;
    assignments: MatchAssignment[];
}


export class Assigner 
{

    public static execute(matchConfig: MatchConfig, sessionProfile: SessionProfile) : SessionProfile
    {
        // clear lead source and category data
        sessionProfile.leadSources = [];
        sessionProfile.leadSourceCategories = [];
        // iterate through assignments and assign source data
        // from the first matching assignment
        for(let i = 0; i < matchConfig.assignments.length; i ++) {
            let assign = true;
            const assignment = matchConfig.assignments[i];
            for(let j = 0; j < assignment.clauses.length; j ++) {
                const clause = assignment.clauses[j];
                if (!Assigner.checkClause(clause, sessionProfile)) {
                    // move to next assignment
                    assign = false;
                    break;
                }
            }
            if (assign) {
                for(let l = 0; l < assignment.assignSources.length; l ++) {
                    sessionProfile.leadSources.push(assignment.assignSources[l]);
                }
                for(let m = 0; m < assignment.assignCategories.length; m ++) {
                    sessionProfile.leadSourceCategories.push(assignment.assignCategories[m]);
                }    
            }
        }
        return sessionProfile;
    }

    protected static checkClause(clause: MatchClause, sessionProfile: SessionProfile) : boolean
    {
        if (clause.attribute === SessionProfileAttribute.allValues) {
            // no evaluations allowed against the allValues attribute
            return false;
        }
        let rawValues = sessionProfile[clause.attribute];
        if (rawValues.length === 0 && clause.matchValues.length > 0) {
            // no raw values to check against the clause criteria
            return false;
        }
        if (clause.primaryOnly) {
            // @ts-ignore
            rawValues = [rawValues[0]];
        }
        for (let j = 0; j < rawValues.length; j ++) {
            const rawValue = String(rawValues[j]);
            for (let k = 0; k < clause.matchValues.length; k ++) {
                const matchValue = clause.matchValues[k];
                if (matchValue.isRegex) {
                    const regExp = new RegExp(matchValue.value);
                    if (!regExp.test(rawValue)) {
                        if (matchValue.isNegative === false) {
                            return false;   
                        }
                    } else {
                        if (matchValue.isNegative === true) {
                            return false;
                        }
                    }
                } else {
                    if (rawValue.toLocaleLowerCase() !== matchValue.value.toLocaleLowerCase()) {
                        if (matchValue.isNegative === false) {
                            return false;
                        }
                    } else {
                        if (matchValue.isNegative === true) {
                            return false;
                        }
                    }    
                }
            }
        }
        return true;
    }

}
